import { __awaiter, __extends, __generator } from "tslib";
/* eslint-disable @typescript-eslint/require-await */
import { BaseApi } from '../BaseApi';
import { query as setAddressMutation } from '../../graphql/setAddress.graphql';
import { query as setCartShippingAddressAndDestination } from '../../graphql/setCartShippingAddressAndDestination.graphql';
import { query as setCartBillingAddress } from '../../graphql/setCartBillingAddress.graphql';
import { query as setCartShippingAddressesForFastFlowEstimation } from '../../graphql/setCartShippingAddressesForFastFlowEstimation.graphql';
import { query as setCartAddressesAndDestinationFromSingleAddress } from '../../graphql/setCartAddressesAndDestinationFromSingleAddress.graphql';
import { query as setCartShippingOption } from '../../graphql/setCartShippingOption.graphql';
import { query as submitPaymentMutation } from '../../graphql/submitPayment.graphql';
import { GraphQLOperations } from '../constants';
var CheckoutLegacyApi = /** @class */ (function (_super) {
    __extends(CheckoutLegacyApi, _super);
    function CheckoutLegacyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckoutLegacyApi.prototype.setAddress = function (variables) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mutate({
                            variables: variables,
                            query: setAddressMutation,
                            operationName: GraphQLOperations.SetAddress,
                        })];
                    case 1: return [2 /*return*/, (_a.sent()).checkout.setAddress.cartService.cart];
                }
            });
        });
    };
    CheckoutLegacyApi.prototype.setCartShippingAddressAndDestination = function (variables) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mutate({
                            variables: variables,
                            query: setCartShippingAddressAndDestination,
                            operationName: GraphQLOperations.SetCartShippingAddressAndDestination,
                        })];
                    case 1: return [2 /*return*/, (_a.sent()).checkout.setCartShippingAddressAndDestination.cartService.cart];
                }
            });
        });
    };
    CheckoutLegacyApi.prototype.setCartBillingAddress = function (variables) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mutate({
                            variables: variables,
                            query: setCartBillingAddress,
                            operationName: GraphQLOperations.SetCartBillingAddress,
                        })];
                    case 1: return [2 /*return*/, (_a.sent()).checkout.setCartBillingAddress.cartService.cart];
                }
            });
        });
    };
    CheckoutLegacyApi.prototype.setCartShippingAddressesForFastFlowEstimation = function (variables) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mutate({
                            variables: variables,
                            query: setCartShippingAddressesForFastFlowEstimation,
                            operationName: GraphQLOperations.SetCartShippingAddressesForFastFlowEstimation,
                        })];
                    case 1: return [2 /*return*/, (_a.sent()).checkout.setCartShippingAddressesForFastFlowEstimation.cartService.cart];
                }
            });
        });
    };
    CheckoutLegacyApi.prototype.setCartAddressesAndDestinationFromSingleAddress = function (variables) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mutate({
                            variables: variables,
                            query: setCartAddressesAndDestinationFromSingleAddress,
                            operationName: GraphQLOperations.SetCartAddressesAndDestinationFromSingleAddress,
                        })];
                    case 1: return [2 /*return*/, (_a.sent()).checkout.setCartAddressesAndDestinationFromSingleAddress.cartService.cart];
                }
            });
        });
    };
    CheckoutLegacyApi.prototype.setCartShippingOption = function (variables) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mutate({
                            variables: variables,
                            query: setCartShippingOption,
                            operationName: GraphQLOperations.SetCartShippingOption,
                        })];
                    case 1: return [2 /*return*/, (_a.sent()).checkout.setShippingOption.cartService.cart];
                }
            });
        });
    };
    CheckoutLegacyApi.prototype.submitPayment = function (variables) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mutate({
                            variables: variables,
                            query: submitPaymentMutation,
                            operationName: GraphQLOperations.SubmitPayment,
                        })];
                    case 1: return [2 /*return*/, (_a.sent()).checkout.submitPayment];
                }
            });
        });
    };
    return CheckoutLegacyApi;
}(BaseApi));
export { CheckoutLegacyApi };
//# sourceMappingURL=CheckoutLegacyApi.js.map